import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Batch extends Vue {
  @Prop()
    index: number;

  @Prop()
    ind: number;

  @Prop({ default: 0 })
    maxlength: number;

  @Prop({ default: '价格' })
    priceText: string;

  @Prop({ default: '库存' })
    stockText: string;

  @Prop({ default: '' })
    groupText: string;

  @Prop({ default: 'price' })
    priceKey: string;

  @Prop({ default: 'stock' })
    stockKey: string;

  @Prop({ default: '' })
    groupKey: string;

  @Prop({ default: 0 })
    minStock: number;
    
  @Prop({ default: 2 })
    precision: number

  public val = 0;

  public setType = '';

  public setName = '';

  public select = false;

  get getMinInput() {
    return this.setType == 'stock' ? this.minStock : 0.01;
  }

  mounted() {
    this.val = this.minStock;
  }

  handleSet(name, type, precision) {
    this.select = true;
    this.setName = name;
    this.setType = type;
    this.precision = precision;
    this.val = 0;
  }

  handleSave() {
    this.$emit('confirm', this.index, this.setType, this.val, this.ind);
    this.select = false;
    this.val = 0;
  }

  handleCancel() {
    this.select = false;
    this.val = 0;
    this.$emit('cancel', this.index, this.ind);
  }

  handleEditGoodSave() {
    this.$emit('handleEditGoodSave', this.index, this.ind);
  }

  handleEditGoodCancel() {
    this.$emit('handleEditGoodCancel', this.index, this.ind);
  }
}
